export enum TRACK_TYPE {
  CLICK = 'click',
  VIEW = 'view',
  API_ERROR = 'api_error',
  API_SUCCESS = 'api_success',
}

export enum CATEGORY {
  AUTH = 'auth',
  BILLING = 'billing',
  DESTINATION = 'destination',
  SIDEBAR = 'sidebar',
  DIRECTORY = 'directory',
  PROFILE = 'profile',
  EVENT_LIMIT = 'Event Limit Page viewed',
  MODEL = 'SQL model',
}

export const BI_EVENTS = {
  // Auth
  LOGIN: 'Login',
  SIGNUP_WITH_GOOGLE: 'Signup with google',
  PRIVACY_POLICY: 'privacy_policy',
  TERMS_OF_SERVICE: 'terms_of_service',
  SIGNED_UP: 'ads_cnv_app_signup',
  SIGNED_UP1: 'User Signed Up',
  SIGN_UP_WITH_EMAIL: 'Signup with email',
  // Directory
  DESTINATION_CLICK: 'Destination clicked',

  // Billing
  UPGRADE_PLAN: 'Upgrade Plan clicked',
  PRICING_BREAKDOWN: 'Billing view pricing breakdown',
  PROFILE_CLICKED: 'Profile Clicked',
  // Destination
  NEW_DEST: 'new destination created',
  INTEGRATION_REQUEST: 'New Integration requested',

  // PROFILE
  UpdateName: 'General name updated successfully',
  UpdateNameFailure: 'General name update failure',
  UpdatePassword: 'General password updated successfully',
  PasswordFailure: 'General password update failure',
  // Event Limit
  EventLimit: 'Event limit page viewed',
  AdminUpgradeClick: 'Request Admin to upgrade clicked',
  AdminUpgradeSent: 'Request Admin to upgrade sent',
  AdminUpgradeFailed: 'Request Admin to upgrade failed',
  ContinueToApp: 'Continue to App clicked',
  ExplorePlans: 'Explore Plans Clicked',
  Sales: 'Chat with Sales clicked',
  Pro: 'RudderStack Pro clicked',

  // SQL Model
  NEW_MODEL: 'New SQL model created',
  USE_MODEL: 'New SQL model is being used in connection',

  CREATE_CONNECTION: 'connection created',
  LIVE_EVENTS_VIEWED: 'live_events_viewed',
  CONNECTION_DISABLED: 'connection_disabled', // Check with product
  CONNECTION_ENABLED: 'connection_enabled', // Check with product
  SOURCE_SETUP_STARTED: 'source_setup_started',
  SOURCE_SETUP_STEP_COMPLETED: 'source_setup_step_completed', // TODO
  SOURCE_CREATED: 'new source created',
  DESTINATION_SETUP_STARTED: 'destination_setup_started',
  DESTINATION_SETUP_STEP_COMPLETED: 'destination_setup_step_completed',
  TRANSFORMATION_CREATED: 'transformation created',
  LIBRARY_CREATED: 'library_created',
  INVITE_TEAM_MEMBERS: 'invite_team_members',
  SEARCH: 'search',
  LOGGED_IN: 'logged_in',
  ACCOUNT_CREATED: 'account_created',
};
